import React from 'react'
import Pagination from '../Pagination'

/**
 * Operations table shell: header toolbar, scrollable nx-table, pagination footer.
 */
const DataTableShell = ({
  toolbar,
  children,
  footer,
  currentPage,
  setCurrentPage,
  totalPages,
  minWidth = '780px',
  className = '',
  dense = false,
}) => (
  <section className={`nx-panel overflow-hidden ${className}`}>
    {toolbar}
    <div className="nx-table-wrap rounded-none border-0 border-t border-rule">
      <div className="overflow-x-auto">
        <table
          className={`nx-table ${dense ? 'nx-table-dense' : ''}`}
          style={{ minWidth }}
        >
          {children}
        </table>
      </div>
    </div>
    {(footer || (currentPage != null && setCurrentPage && totalPages != null)) && (
      <div className="flex items-center justify-center border-t border-rule bg-surface px-4 py-3 text-paper">
        {footer || (
          <Pagination
            currentPage={currentPage}
            setCurrentPage={setCurrentPage}
            totalPages={totalPages}
          />
        )}
      </div>
    )}
  </section>
)

export default DataTableShell
